
export const postUrl = ({ domainName, userName, postId }: { domainName: string; userName: string; postId: string }) => {
    return `https://${domainName}/members/@${encodeURIComponent(userName)}/posts/${encodeURIComponent(postId)}`
}